import { Component } from '@angular/core';
import { IonNav, ModalController, ViewWillEnter } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { Order } from '@usf/ngrx-order';
import { ServiceRequestService } from '@service-request/services/service-request.service';
import { ServiceRequestAnalyticsService } from '@usf/ngrx-list';
import { ProductReview } from '@shared/models/product-review.model';

@Component({
  template: '',
})
export class OrderAndProductOptionsBaseComponent implements ViewWillEnter {
  constructor(
    protected nav: IonNav,
    private modalController: ModalController,
    readonly platformService: PlatformService,
    public serviceRequestService: ServiceRequestService,
    private serviceRequestAnalyticsService: ServiceRequestAnalyticsService,
  ) {}

  ionViewWillEnter(): void {
    this.serviceRequestService.getRequestCreditOrders();
    if (this.serviceRequestService.modalRelatedParams.order) {
      this.serviceRequestService.getProducts(
        this.serviceRequestService.modalRelatedParams.order,
      );
    }
  }

  async getProductsByOrder(selectedOrder: Order) {
    this.serviceRequestService.setModalOrderAndProduct(
      selectedOrder,
      undefined,
    );
    this.serviceRequestService.searchKey = '';
    this.serviceRequestAnalyticsService.trackRequestCreditStart(
      selectedOrder.orderHeader.orderId,
    );
    if (
      this.platformService.platformType ===
      this.platformService.platformEnum.desktop
    ) {
      this.serviceRequestService.getProducts(selectedOrder);
    }
  }

  filterProductNumbers() {
    this.serviceRequestService.onProductSearch(
      this.serviceRequestService.modalRelatedParams.order,
    );
  }

  onSelectProduct(productReview: ProductReview) {
    this.serviceRequestService.setModalOrderAndProduct(
      this.serviceRequestService.modalRelatedParams.order,
      productReview,
    );
  }

  getOrderTypeLabel(order: Order): string {
    return order
      ? 'i18n.requestCredit.orderType' + order.orderHeader?.orderType
      : '-';
  }

  async dismissModal(needValueReset: boolean = true) {
    this.serviceRequestService.searchKey = '';
    if (!needValueReset) {
      // to reset issue and issue details when revisiting order/product for pickup value reset.
      this.serviceRequestService.setModalOrderAndProduct(
        this.serviceRequestService.modalRelatedParams.order,
        this.serviceRequestService.modalRelatedParams.product,
      );
      this.serviceRequestService.checkProduct(
        this.serviceRequestService.modalRelatedParams.product,
        this.serviceRequestService.modalRelatedParams.order,
      );
    }
    await this.modalController.dismiss(needValueReset);
  }
}
